import Svg, { Path } from "react-native-svg";

export function GoogleIcon() {
  return (
    <Svg width={16} height={16} viewBox="0 0 24 24" fill="none">
      <Path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <Path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <Path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <Path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </Svg>
  );
}

export function AppleIcon() {
  return (
    <Svg width={16} height={16} viewBox="0 0 24 24">
      <Path
        d="M17.05 20.28c-.98.95-2.05.88-3.08.38-1.07-.52-2.05-.51-3.21 0-1.05.47-2.1.55-3.16-.35-2.27-2.27-2.79-6.32-.61-9.73 1.09-1.7 2.92-2.58 4.79-2.56 1.41.01 2.38.74 3.03.74.65 0 1.94-.78 3.52-.66 1.34.09 2.53.64 3.38 1.63-2.92 1.5-2.36 5.86.51 7.15-.55 1.55-1.34 2.89-2.17 3.4zm-3.64-16.1c.54-1.28 1.96-2.23 3.5-2.17.26 1.48-.68 2.89-1.99 3.48-1.26.65-2.69-.17-3.07-1.36-.06-.18-.1-.4-.08-.62.06.2.14.43.26.64.12.2.3.36.38.03z"
        fill="rgba(255, 255, 255, 0.94)"
      />
    </Svg>
  );
}
